export default __webpack_public_path__ + "static/media/SignIn.7995369f.svg";